import Workflow from 'src/models/workflow';
import { RegistrationStep, WorkflowContext, MaxAllowedAttemptsStepOne, MaxAllowedAttemptsStepTwo } from './constValues';
import { Base64 } from 'js-base64';
import { isNullOrEmpty } from './formater';
import { rollbar } from 'src';

export function getCurrentStepRouter(workflow: Workflow, attachmentCurrentPath?: string): string {
    switch (workflow && workflow.currentStep) {
        case RegistrationStep.ProviderInformation:
            return `/registration/provider`;
        case RegistrationStep.ExperianQuestions:
            return `/registration/experian`;
        case RegistrationStep.ClinicInformation:
            return `/registration/clinic`;
        case RegistrationStep.ContractAgreement:
            return `/registration/agreement`;
        case RegistrationStep.PaymentInformation:
            return `/registration/payment`;
        case RegistrationStep.Attachments:
            return attachmentCurrentPath
                && attachmentCurrentPath !== ''
                && attachmentCurrentPath.includes('/registration/attachment/addedit')
                ? attachmentCurrentPath
                : `/registration/attachment`;
        case RegistrationStep.Summary:
            return `/registration/summary`;
        case RegistrationStep.CompleteWithFailAllowedRetry:
            return `/registration/completewithfailallowedretry`;
        case RegistrationStep.CompleteWithPermanentFail:
            return `/registration/completewithpermanentfail`;
        case RegistrationStep.FailUserExist:
            return `/registration/existuser`;

        default:
            return '';
    }
}

export function storeWorkflowContextData(key: string, value: string): boolean {
    try {
        if (typeof (Storage) !== undefined) {
            // localStorage.setItem(key, value);
            let encryptData = Base64.encode(value); // Base64.decode() decodes to UTF-8 string while Base64.atob() decodes to bytes (use for image)
            sessionStorage.setItem(key, encryptData);
            return true;
        } else {
            console.log(`Browser does not support support local storage`);
            return false;
        }
    } catch {
        console.log(`Can not save ${key} to local storage!`);
        rollbar.error(`Can not save ${key} to local storage!`);
        return false;
    }
}

export function getWorkflowContextData(key: string): string {
    try {
        if (typeof (Storage) !== undefined) {
            // const value = localStorage.getItem(key);
            const value = sessionStorage.getItem(key);
            if (!value) {
                return '';
            }
            return Base64.decode(value);
        } else {
            console.log(`Browser does not support support local storage`);
            return '';
        }
    } catch (err) {
        console.log(`Can not get ${key} from local storage!`);
        rollbar.error(`Can not get ${key} from local storage!`);
        return '';
    }
}

export function removeWorkflowContextData(key: string): void {
    try {
        if (typeof (Storage) !== undefined) {
            // localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        } else {
            console.log(`Browser does not support support local storage`);
        }
    } catch (err) {
        console.log(`Can not remove ${key} from local storage!`);
        rollbar.error(`Can not remove ${key} from local storage!`);
    }
}

export function increaseAttemptCounter(inStepOne: boolean): void {
    let attempCounterValue = getWorkflowContextData(inStepOne ? WorkflowContext.ATTEMPT_COUNTER_STEP_ONE : WorkflowContext.ATTEMPT_COUNTER_STEP_TWO);
    let failCount = JSON.parse(attempCounterValue !== '' ? attempCounterValue : '0') as number;
    storeWorkflowContextData(inStepOne ? WorkflowContext.ATTEMPT_COUNTER_STEP_ONE : WorkflowContext.ATTEMPT_COUNTER_STEP_TWO, (failCount + 1).toString());
}

export function retryAllowed(inStepOne: boolean): boolean {
    let attempCounterValue = getWorkflowContextData(inStepOne ? WorkflowContext.ATTEMPT_COUNTER_STEP_ONE : WorkflowContext.ATTEMPT_COUNTER_STEP_TWO);
    let failCount = JSON.parse(!isNullOrEmpty(attempCounterValue) ? attempCounterValue :
        inStepOne ? MaxAllowedAttemptsStepOne.toString() : MaxAllowedAttemptsStepTwo.toString()) as number;
    console.log('Fail count value: ', failCount);
    return failCount < (inStepOne ? MaxAllowedAttemptsStepOne : MaxAllowedAttemptsStepTwo);
}

export function getRetryTimes(inStepOne: boolean): number {
    let attempCounterValue = getWorkflowContextData(inStepOne ? WorkflowContext.ATTEMPT_COUNTER_STEP_ONE : WorkflowContext.ATTEMPT_COUNTER_STEP_TWO);
    let failCount = JSON.parse(!isNullOrEmpty(attempCounterValue) ? attempCounterValue :
        inStepOne ? MaxAllowedAttemptsStepOne.toString() : MaxAllowedAttemptsStepTwo.toString()) as number;
    return (inStepOne ? MaxAllowedAttemptsStepOne : MaxAllowedAttemptsStepTwo) - failCount;
}

export function setAttemptCounter(counter: string, inStepOne: boolean): void {
    storeWorkflowContextData(inStepOne ? WorkflowContext.ATTEMPT_COUNTER_STEP_ONE : WorkflowContext.ATTEMPT_COUNTER_STEP_TWO, counter);
}

export function workflowAllowedRetry(): Workflow {
    let workflow: Workflow = {
        sessionId: '',
        currentStep: RegistrationStep.CompleteWithFailAllowedRetry,
        isCurrentStepFinished: false,
        currentStepHasErrors: true
    };
    return workflow;
}

export function workflowPermanentFail(): Workflow {
    let workflow: Workflow = {
        sessionId: '',
        currentStep: RegistrationStep.CompleteWithPermanentFail,
        isCurrentStepFinished: false,
        currentStepHasErrors: true
    };
    return workflow;
}

export function workflowFailUserExist(): Workflow {
    let workflow: Workflow = {
        sessionId: '',
        currentStep: RegistrationStep.FailUserExist,
        isCurrentStepFinished: false,
        currentStepHasErrors: true
    };
    return workflow;
}

export function clearSessionStorage(): void {
    removeWorkflowContextData(WorkflowContext.EXPERIAN_SESSION_ID);
    removeWorkflowContextData(WorkflowContext.EXPERIAN_QUESTIONS);
    removeWorkflowContextData(WorkflowContext.WorkingRegistrationId);
    removeWorkflowContextData(WorkflowContext.PROVIDER_INFO_PAYMENT);
    removeWorkflowContextData(WorkflowContext.PROVIDER_INFORMATION_PAYMENT);
}


// WEBPACK FOOTER //
// ./src/utils/workflow.ts